import { combineReducers } from 'redux';

import login from './Login';
import Signup from './Signup';
import commissionReducer from "./Commission";
import sessionReducer from './sessionReducer';


export default combineReducers({
  login,
  Signup,
  commissionReducer,
  sessionReducer
});